import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import React, { FC } from "react";
import { Divider } from "primereact/divider";
import { T } from "services/lang/LanguageService";
import DialIndicatorMinMaxValueEditor from "./DialIndicatorMinMaxValueEditor";
import { DialIndicatorEditorProps } from "./DialIndicatorTypes";

const DialIndicatorDatasetsEditor: FC<DialIndicatorEditorProps> = ({ config, onConfigChange }) => {
  return (
    <div className="flex flex-column w-12">
      <div className="flex flex-column gap-2">
        <label htmlFor="valueDataset">{T("word.dataset")}</label>
        <DatasetDropdown
          value={config.valueDataset}
          onChange={val => onConfigChange({ ...config, valueDataset: val ?? undefined })}
        />
      </div>
      <Divider />
      <DialIndicatorMinMaxValueEditor config={config} onConfigChange={onConfigChange} isMinValue />
      <Divider />
      <DialIndicatorMinMaxValueEditor
        config={config}
        onConfigChange={onConfigChange}
        isMinValue={false}
      />
    </div>
  );
};

export default DialIndicatorDatasetsEditor;
